import { ClickAwayListener, Paper, Popper } from '@mui/material';
import { inject, observer } from 'mobx-react';
import ReactComponent from './ReactComponent';

class PopoverSecretaria extends ReactComponent {
    render() {
        return (
            <Popper
                open={this.props.open}
                anchorEl={this.props.anchorEl}
                placement={this.props.placement || 'bottom-start'}
                style={{ zIndex: 1300, borderRadius: '4px', ...this.props.style }}
            >
                <Paper
                    style={{
                        boxShadow:
                            '0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12)',
                        padding: this.props.padding || '10px',
                        overflow: this.props.overflow
                    }}
                >
                    <ClickAwayListener onClickAway={this.props.onClose}>
                        <div>{this.props.children}</div>
                    </ClickAwayListener>
                </Paper>
            </Popper>
        );
    }
}

export default inject('stores')(observer(PopoverSecretaria));
